// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"ya","cross":"yb","iconSVGWrapper":"yc","iconSVG":"yd","iconSVGDark":"ye"};